import { CheckCircleOutline, Close, ErrorOutline, ExpandLess, ExpandMore, HourglassEmpty } from '@mui/icons-material';
import { Box, IconButton, LinearProgress, Paper, Tooltip, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import ResumoAguiaGeracaoStore, { GeracaoResumoAguia } from '../../../store/ResumoAguiaGeracaoStore';

class ResumoAguiaGeracaoToolbar extends React.Component {
    renderIconeStatus(geracao: GeracaoResumoAguia) {
        const tooltip = geracao.mensagem || this.renderStatus(geracao);
        let icone;

        if (geracao.status === 'concluido') {
            icone = <CheckCircleOutline color='success' fontSize='small' />;
        } else if (geracao.status === 'erro') {
            icone = <ErrorOutline color='error' fontSize='small' />;
        } else {
            icone = <HourglassEmpty color='warning' fontSize='small' />;
        }

        return (
            <Tooltip title={tooltip}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {icone}
                </Box>
            </Tooltip>
        );
    }

    renderStatus(geracao: GeracaoResumoAguia) {
        if (geracao.status === 'concluido') {
            return 'Concluido';
        }

        if (geracao.status === 'erro') {
            return 'Erro';
        }

        return 'Gerando resumo...';
    }

    render() {
        if (!ResumoAguiaGeracaoStore.possuiGeracoes) {
            return null;
        }

        return (
            <Paper
                elevation={8}
                sx={{
                    position: 'fixed',
                    left: 16,
                    bottom: 16,
                    zIndex: 1350,
                    width: ResumoAguiaGeracaoStore.expandido ? 390 : 280,
                    maxWidth: 'calc(100vw - 32px)',
                    overflow: 'hidden',
                    borderRadius: '6px'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        padding: '8px 10px',
                        backgroundColor: 'background.paper',
                        borderBottom: ResumoAguiaGeracaoStore.expandido ? '1px solid' : 'none',
                        borderColor: 'divider'
                    }}
                >
                    <HourglassEmpty color='warning' fontSize='small' />
                    <Typography variant='body2' sx={{ fontWeight: 600, flexGrow: 1 }}>
                        Geração de resumos ÁguIA
                        {ResumoAguiaGeracaoStore.quantidadeGerando > 0 ? ` (${ResumoAguiaGeracaoStore.quantidadeGerando})` : ''}
                    </Typography>
                    <Tooltip title={ResumoAguiaGeracaoStore.expandido ? 'Recolher' : 'Expandir'}>
                        <IconButton size='small' onClick={() => ResumoAguiaGeracaoStore.toggleExpandido()}>
                            {ResumoAguiaGeracaoStore.expandido ? <ExpandMore fontSize='small' /> : <ExpandLess fontSize='small' />}
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Fechar'}>
                        <IconButton size='small' onClick={() => ResumoAguiaGeracaoStore.limpar()}>
                            <Close fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </Box>

                {ResumoAguiaGeracaoStore.expandido && (
                    <Box sx={{ maxHeight: 260, overflowY: 'auto' }}>
                        {ResumoAguiaGeracaoStore.geracoes.map(geracao => (
                            <Box
                                key={geracao.idProcesso}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '24px 1fr 32px',
                                    gap: 1,
                                    alignItems: 'center',
                                    padding: '8px 10px',
                                    borderBottom: '1px solid',
                                    borderColor: 'divider'
                                }}
                            >
                                {this.renderIconeStatus(geracao)}
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography variant='body2' noWrap title={geracao.numeroProcesso}>
                                        {geracao.numeroProcesso}
                                    </Typography>
                                    <Tooltip title={geracao.mensagem || this.renderStatus(geracao)}>
                                        <Typography variant='caption' color='text.secondary' noWrap component='div'>
                                            {geracao.mensagem || this.renderStatus(geracao)}
                                        </Typography>
                                    </Tooltip>
                                    {geracao.status === 'gerando' && <LinearProgress sx={{ marginTop: '4px' }} />}
                                </Box>
                                {/*{geracao.status !== 'gerando' ? (
                                    <Tooltip title='Remover da lista'>
                                        <IconButton size='small' onClick={() => ResumoAguiaGeracaoStore.remover(geracao.idProcesso)}>
                                            <Close fontSize='small' />
                                        </IconButton>
                                    </Tooltip>
                                ) : <Box />}*/}
                                <Box />
                            </Box>
                        ))}
                    </Box>
                )}
            </Paper>
        );
    }
}

export default observer(ResumoAguiaGeracaoToolbar);
